var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c43127aa-9c75-43c5-8712-51d6d2ce62f2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201.617 201.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-531fb244-2067-49d7-9370-6dab25e5324c",
    "data-name": "circle1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100.8085,
    cy: 100.8085,
    r: 98.8085,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.347,12.7651c8.9663-2.8964,18.5312-4.4611,28.4615-4.4611,9.9295,0,19.4937,1.5645,28.4593,4.4604",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2583,79.7121H14.2074c7.22-29.7801,29.4-53.71,58.14-63.39V6.1623",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4074,79.7121h9.95219s-9.95219,0-9.95219-.0001c-7.22-29.78-29.4-53.7099-58.14-63.3899V6.1623",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.2392,
    y1: 75.3778,
    x2: 196.4061,
    y2: 75.3778,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.3779,
    y1: 75.3778,
    x2: 5.211,
    y2: 75.3778,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.347,188.8519c8.9663,2.8964,18.5312,4.4612,28.4615,4.4612,9.9295,0,19.4937-1.5645,28.4593-4.4604",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2583,121.905H14.2074c7.22,29.7801,29.4,53.71,58.14,63.3899v10.1599",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4074,121.905h0c-7.22,29.7801-29.4,53.71-58.14,63.3899v10.1599",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2583,79.7121H14.2074c7.22-29.7801,29.4-53.71,58.14-63.39V6.1623",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4074,79.7121h9.95219s-9.95219,0-9.95219-.0001c-7.22-29.78-29.4-53.7099-58.14-63.3899V6.1623",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2583,121.905H14.2074c7.22,29.7801,29.4,53.71,58.14,63.3899v10.1599",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4074,121.905h0c-7.22,29.7801-29.4,53.71-58.14,63.3899v10.1599",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.2392,
    y1: 126.2393,
    x2: 196.4061,
    y2: 126.2393,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.3779,
    y1: 126.2393,
    x2: 5.211,
    y2: 126.2393,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemBorder);
export default __webpack_public_path__ + "static/media/item-border.942b1391e7a2cd56368096545e2c0f47.svg";
export { ForwardRef as ReactComponent };